<div class="ttmodal" id="schematicmasterWindow">
  <div id="schematicWindowHeader_" class="ttmodal__header">
    <span class="ttmodal__title">{{'Edit Action' | translate | async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <div class="dialog-content">
    <div class="ttmodal__body">
      <div class="flex-row">
        <mat-form-field class="input">
          <input matInput readonly [matDatepicker]="myDatepicker" (click)="myDatepicker.open()" placeholder="{{'Date of Action' | translate | async}}" [(ngModel)]="actionDateNew" (ngModelChange)="ChecklastInspectionDateAndSMU()">
          <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #myDatepicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="input">
          <input matInput placeholder="{{'SMU/Hourmeter at Action Date' | translate | async}}" type="text" style="background: white; border: 0px solid #ffffff !important; " [(ngModel)]="actionSMUNew" (change)="ChecklastInspectionDateAndSMU()"
                 ngDefaultControl required>
        </mat-form-field>
       
          <mat-form-field class="input" *ngIf="showPropelHrsPerc">
            <input matInput type="number" [(ngModel)]="actionPMU" placeholder="{{'Propel Hours' | translate | async}}" >
          </mat-form-field>
       
      </div>
      <div class="flex-row">
        <mat-form-field class="input" *ngIf="enableDistTravelledTracking">
          <input matInput placeholder="{{'Distance Forward' | translate | async}}" type="number" [(ngModel)]="distanceForward" (ngModelChange)="calculateTotal()"
                 ngDefaultControl>
        </mat-form-field>

        <mat-form-field class="input" *ngIf="enableDistTravelledTracking">
          <input matInput placeholder="{{'Distance Reverse' | translate | async}}" type="number" [(ngModel)]="distanceReverse" (ngModelChange)="calculateTotal()"
                 ngDefaultControl>
        </mat-form-field>

        <mat-form-field class="input" *ngIf="enableDistTravelledTracking">
          <input matInput placeholder="{{'Total Distance' | translate | async}}"
                 type="number"
                 [(ngModel)]="totalDistance"
                 readonly
                 ngDefaultControl>
        </mat-form-field>
      </div>
      <div class="tt-footer1">
        <div *ngIf="ShowWarning">
          <span *ngIf="ShowWarning" class="headerlabel" style="font-weight: bold;color: red;">{{warning}}</span>
        </div>
        <button mat-raised-button color="warn" [disabled]="loading && !ShowWarning" [class.loading]="loading" (click)="UpdateAction()" class="action-button-fixedwidth">
          <span class="material-icons button__icon">save</span>
          <span class="button__text">{{'Update Action Details'| translate | async}}</span>
        </button>
      </div>
    </div>
    <div class="panel-history">
      <span class="ttmodal__title">Action(s) Performed on date: {{actionDateStr}}</span>
    </div>
    <div class="panel__content">
      <table class="table table--striped table--full-width">
        <thead>
          <tr>
            <th>
              <mat-checkbox [(ngModel)]="selectAll" (change)="toggleSelectAll($event.checked)">
              </mat-checkbox>
            </th>
            <th>
              {{ 'Action Desc' | translate | async }}
            </th>

            <th>
              {{ 'Comment' | translate | async }}
            </th>

            <th>
              {{ 'Side' | translate | async }}
            </th>

            <th>
              {{ 'Pos' | translate | async }}
            </th>
            <th>
              {{ 'Entered By' | translate | async }}
            </th>

            <th>
              {{ 'Entered Date' | translate | async }}
            </th>
          </tr>
        </thead>
        <tbody style="border-bottom: 1px solid #E9EDF2;">
          <tr *ngFor="let data of actionHistoryList">
            <td><mat-checkbox [(ngModel)]="data.selected" (change)="checkIfAllSelected()"></mat-checkbox></td>
            <td class="tdClass">{{data.action_name}} <span *ngIf="data.action_type_auto==10702 || data.action_type_auto==10602">{{data.ReplacedPos}}</span></td>
            <td class="tdClass">{{data.comment}}</td>
            <td class="tdClass">{{data.side != null ? data.side == 2 ? "Right" : data.side == 1 ? "Left" : "" : ""}}</td>
            <td class="tdClass">{{data.pos}}</td>
            <td class="tdClass">{{data.entry_user_name}}</td>
            <td class="tdClass">{{data.entry_date | date:'dd MMM yyyy'}}</td>
          </tr>
        </tbody>


      </table>
    </div>
  </div>

  <div class="tt-footer">
    
    <div>
      <button mat-raised-button (click)="onCloseClick()" [disabled]="loading && !ShowWarning" [class.loading]="loading">{{ "Cancel" | translate | async }}</button>
    </div>
    <div style="margin-left: 10px;">
      <button mat-raised-button color="warn" [disabled]="loading && !ShowWarning" [class.loading]="loading" (click)="rollbackEquipmentAction()" class="action-button-fixedwidth">
        <span class="material-icons button__icon">undo</span>
        <span class="button__text">{{'Rollback Full Action'| translate | async}}</span>
      </button>
    </div>

  </div>


</div>

